import React, { useState } from 'react';
import './Projects.css';

const Projects = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const projects = [
    {
      title: 'Nerde_Ne_Yesek?',
      description: 'Türkiye\'nin yöresel yemekleri hakkında bilgi edinmek için güzel kaynak olması açısından yaptığım tanıtımını yapamadığım ilk amatör uygulamam',
      link: 'https://play.google.com/store/apps/details?id=com.enes.nerdeneyesek&hl=tr',
      tech: ['MOBILE', 'ANDROID', 'FOOD_APP'],
      status: 'LIVE',
      downloads: '50+',
      color: '#ff0040'
    },
    {
      title: 'ReFoto',
      description: 'ReFoto, kullanıcıların doğal dilde (promptlarla) komut vererek fotoğraflarını düzenleyebildiği bir mobil uygulamadır.',
      link: 'https://play.google.com/store/apps/details?id=com.enes.refoto',
      tech: ['MOBILE', 'AI', 'PHOTO_EDIT'],
      status: 'LIVE',
      downloads: '100+',
      color: '#00ffff'
    }
  ];

  return (
    <section className="projects-section">
      <div className="projects-container">
        <div className="section-header">
          <span className="section-number">[04]</span>
          <h2 className="section-title">
            <span className="glitch" data-text="PROJECT_ARCHIVE">PROJECT_ARCHIVE</span>
          </h2>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div 
              key={index} 
              className={`project-card ${hoveredIndex === index ? 'hovered' : ''} ${hoveredIndex !== null && hoveredIndex !== index ? 'dimmed' : ''}`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{ '--project-color': project.color }}
            >
              <div className="card-glow"></div>
              
              <div className="project-header">
                <div className="project-number">0{index + 1}</div>
                <div className="project-status">
                  <span className="status-dot"></span>
                  {project.status}
                </div>
              </div>

              <div className="project-body">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>

                <div className="tech-stack">
                  {project.tech.map((tech, i) => (
                    <span key={i} className="tech-tag">{tech}</span>
                  ))}
                </div>

                <div className="project-stats">
                  <div className="stat">
                    <span className="stat-label">DOWNLOADS</span>
                    <span className="stat-value">{project.downloads}</span>
                  </div>
                  <div className="stat">
                    <span className="stat-label">PLATFORM</span>
                    <span className="stat-value">ANDROID</span>
                  </div>
                </div>
              </div>

              <a 
                href={project.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="project-link"
              >
                <span className="link-text">GOOGLE_PLAY</span>
                <span className="link-arrow">→</span>
              </a>

              <div className="card-corner-glow top-left"></div>
              <div className="card-corner-glow top-right"></div>
              <div className="card-corner-glow bottom-left"></div>
              <div className="card-corner-glow bottom-right"></div>
            </div>
          ))}
        </div>

        <div className="projects-footer">
          <div className="footer-line"></div>
          <div className="footer-text">
            <span className="bracket">{'['}</span>
            MORE_PROJECTS_COMING_SOON
            <span className="bracket">{']'}</span>
          </div>
          <div className="footer-line"></div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
